import angular from 'angular';

import { MeurhContribuintesIndividuaisIndexController } from './index/contribuintesindividuais.index.controller';
import { MeurhContribuintesIndividuaisNewController } from './new/contribuintesindividuais.new.controller';
import { MeurhContribuintesIndividuaisShowController } from './show/contribuintesindividuais.show.controller';

import { MeurhContribuintesIndividuaisFormComponent } from './form/contribuintesindividuais.form.component';

import { MeurhContribuintesIndividuaisService } from './contribuintesindividuais.service';
import { MeurhContribuintesIndividuaisListRouting } from './contribuintesindividuais.routes';

export const MeurhContribuintesIndividuaisModule = angular.module('ContribuintesIndividuaisModule', ['ui.router.state'])
    .controller('MeurhContribuintesIndividuaisIndexController', MeurhContribuintesIndividuaisIndexController)
    .controller('MeurhContribuintesIndividuaisNewController', MeurhContribuintesIndividuaisNewController)
    .controller('MeurhContribuintesIndividuaisShowController', MeurhContribuintesIndividuaisShowController)
    .component('meurhContribuintesIndividuaisFormComponent', MeurhContribuintesIndividuaisFormComponent)
    .service('MeurhContribuintesIndividuaisService', MeurhContribuintesIndividuaisService)
    .config(MeurhContribuintesIndividuaisListRouting)
    .name;
